import api from '../api/api';

/**
 * Admin service for complete cross-class student data access
 * Uses dedicated admin endpoints for extensible reporting
 */
const adminService = {
  /**
   * Get student profile with populated class names (admin view)
   * @param {string} studentId - Student ID
   * @returns {Promise} - Promise containing student data with class names
   */
  getStudentProfile: async (studentId) => {
    try {
      console.log('AdminService: fetching student profile with class names for:', studentId);
      const response = await api.get(`/admin/students/${studentId}/profile`);
      
      // Handle different response formats
      if (response.data && response.data.success) {
        return response.data.data;
      }
      
      return response.data;
    } catch (error) {
      console.error('Error fetching admin student profile:', error);
      throw error;
    }
  },
  /**
   * Get all assignments for a student across all classes (admin view)
   * @param {string} studentId - Student ID
   * @returns {Promise} - Promise containing all assignments
   */
  getStudentAssignments: async (studentId) => {
    try {
      console.log('AdminService: fetching all assignments for student:', studentId);
      const response = await api.get(`/admin/students/${studentId}/assignments`);
      
      // Handle different response formats
      if (response.data && response.data.success) {
        return response.data.data || [];
      }
      
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching admin student assignments:', error);
      throw error;
    }
  },

  /**
   * Get all attendance records for a student across all classes (admin view)
   * @param {string} studentId - Student ID
   * @returns {Promise} - Promise containing all attendance records with class names
   */
  getStudentAttendance: async (studentId) => {
    try {
      console.log('AdminService: fetching all attendance for student:', studentId);
      const response = await api.get(`/admin/students/${studentId}/attendance`);
      
      // Handle different response formats
      if (response.data && response.data.success) {
        return response.data.data || [];
      }
      
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching admin student attendance:', error);
      throw error;
    }
  }
};

export default adminService;